module.exports = __webpack_public_path__ + "img/video-play.4d1fc607.svg";